// Resolved Locale for non-React readers
let resolvedLocale: Intl.Locale | undefined

export function setResolvedLocale(locale: string): void {
  try {
    resolvedLocale = new Intl.Locale(locale)
  } catch {
    resolvedLocale = undefined
  }
}

// Mirror of the localization gate for non-React readers (getLocaleHeaders runs in the
// axios interceptor); synced from LocaleHandler so client requests carry X-Mindtrip-Locale
// only when localization is on, matching the server gate.
let mindtripLocaleHeaderEnabled = false

export function setMindtripLocaleHeaderEnabled(enabled: boolean): void {
  mindtripLocaleHeaderEnabled = enabled
}

export function getLocaleHeaders(): Record<string, string> {
  let locale = resolvedLocale
  if (!locale) {
    try {
      locale = new Intl.Locale(Intl.DateTimeFormat().resolvedOptions().locale)
    } catch {
      locale = undefined
    }
  }
  const localeTag = locale?.baseName ?? navigator.language
  const language = locale?.language

  const headers: Record<string, string> = { "Accept-Language": localeTag }

  if (language && mindtripLocaleHeaderEnabled) {
    headers["X-Mindtrip-Locale"] = localeTag
  }

  return headers
}
